var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivelearns = function SvgActivelearns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-11.982%",
    x2: "88.304%",
    y2: "107.833%",
    id: "Activelearns_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5.296 8.388 3.307-1.13.866-2.678 1.096.148-.047v5.43l-2.787 1.667-2.077.82-4.056-2.285-.623-1.595V5.518l1.752.587-1.442-.55L1.11 4.086l-.27-.483L9.5.296Z",
    fill: "url(#Activelearns_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.788 3.486 9.612.02a.315.315 0 0 0-.224 0L.212 3.486A.332.332 0 0 0 0 3.798c0 .139.085.263.212.311l1.237.467.648.245 2.252.85-.003.06v4.455c0 1.307 1.278 1.793 2.513 2.262.932.355 1.895.721 2.377 1.413l.001.001a.32.32 0 0 0 .483.05c.822-.778 1.776-1.088 2.617-1.362 1.19-.388 2.316-.755 2.316-2.364V5.73l-.002-.058 4.137-1.563A.332.332 0 0 0 19 3.798a.331.331 0 0 0-.212-.312Zm-6.647 8.43c-.782.255-1.737.566-2.602 1.279-.617-.671-1.55-1.026-2.455-1.37-1.3-.494-2.09-.852-2.09-1.64v-4.27l4.394 1.66a.315.315 0 0 0 .224 0l4.393-1.66v4.27c0 1.076-.605 1.321-1.864 1.731ZM9.429 6.883 1.51 3.89a.1.1 0 0 1 0-.187L9.43.713a.2.2 0 0 1 .142 0l7.92 2.991a.1.1 0 0 1 0 .187L9.57 6.883a.2.2 0 0 1-.142 0Z",
    fill: "#006E50",
    fillRule: "nonzero",
    stroke: "#006E50",
    strokeWidth: 0.3
  }))));
};
export default SvgActivelearns;